<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:98%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
			
				<div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 2vh;"
				
				>	
                    <el-upload
                        class="upload-demo"
                        action="/api/admin/uploadimage"
                        :on-success="onsuccess"
                        multiple
                        :limit="1"
                        :file-list="fileList">
                        <el-button size="small" type="primary">上传表情包</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
				</div>

				<div style="height: auto;flex:1;" >
				<el-table
					height="80vh"
				    :data="list"
					border
				    style="width: 100%"
					>
				    <el-table-column
				      label="文件名"
				      width="250"
                      prop="name"
                      >
				    </el-table-column>
                   
                    <el-table-column
				      label="图片"
				    >
                        <template slot-scope="scope">
							 <img :src="'https://image.begonia.cafe/tx/emoji/'+scope.row.name" referrerpolicy="no-referrer" style="width:auto;height: 200px;object-fit: cover;border-radius: 5px;"/>
					    </template>
				    </el-table-column>
                    
                    <el-table-column
					      fixed="right"
					      label="操作"
						  width="180"
					      >
					      <template slot-scope="scope">
							<el-button @click="deleteimage(scope.row)" type="text" size="small">删除</el-button>
					      </template>
					</el-table-column>
				  </el-table>
				</div>
			</div>
		</div>

		
	</div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
        list:[],
        fileList:[],
        type:0,
        show:false,
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {
    onsuccess(e){
         this.$notify({
            title: '成功',
            image: '上传成功',
            type: 'success'
        });
        this.fileList=[];
        this.getmore();
    },
	getmore(){
		post("/api/getemojilist",{}).then((res)=>{
			if(res.data.code==1001){
                 for(var x=0;x<res.data.data.length;x++){
                       this.list.unshift({name:res.data.data[x]})
                    }
            }
		})
	},
    shenheimage(e){
        post("/api/admin/updateimage",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    image: res.data.msg,
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    image: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    },
    deleteimage(e){
        post("/api/admin/deleteimage",{filename:e.name}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    image: res.data.msg,
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    image: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    }
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
